import { app } from '../../app.module'
app
  // アカウントの反応率グラフの表示
  .directive('accountRespondRate', () => {
    return {
      restrict: 'E',
      template: require('./account-respond-rate.pug')(),
    }
  })
